module.exports = __webpack_public_path__ + "static/2017AI-b04212aeb70699d05afdbf98f1a36f5f.png";